/* eslint-disable function-paren-newline */
// Libs
import moment from 'moment';

function MerchantLegalEntityModal(data, relationshipManagerMap) {
    this.tableData = this.createTableData(data, relationshipManagerMap);
    this.pagination = this.createPaginationData(data);
}

MerchantLegalEntityModal.prototype = Object.assign(
    MerchantLegalEntityModal.prototype,
    {
        createTableData(tableData, relationshipManagerMap) {
            if (tableData && tableData.data && tableData.data.length > 0) {
                return tableData.data.map(row => this.createRow(row, relationshipManagerMap));
            }
            return [];
        },
        createPaginationData(data) {
            if (data) {
                const {
                    pageNumber,
                    pageSize,
                    totalNumberOfRecords,
                    totalNumberOfPages,
                    hasNextPage,
                    hasPreviousPage,
                } = data.paging;

                return {
                    hasNextPage,
                    hasPreviousPage,
                    pageNumber,
                    pageSize,
                    totalNumberOfPages,
                    totalNumberOfRecords,
                };
            }
            return {};
        },
        createRow(row, relationshipManagerMap) {
            const { name, entityCode, createdDate, relationshipManagerId, entityStatus, kycStatus } = row;
            return {
                createdDate,
                entityName: name,
                entityCode,entityStatus,kycStatus,
                relationshipManagerId: relationshipManagerMap ? relationshipManagerMap[relationshipManagerId] : '',
            };
        },
        formatData(date) {
            return moment(date).format('DD/MM/YYYY');
        },
    }
);

export default MerchantLegalEntityModal;
